import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const saveGooglePayToken: CheckoutActionCreator = (token: string) => ({
  type: actionTypes.SAVE_GOOGLE_PAY_TOKEN,
  token,
})
